"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightAirportCell = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const CityLabel_1 = require("../../../CityLabel");
const MultiLanguage_1 = require("../../../MultiLanguage");
const FlightAirportCell = (props) => {
    const { airport } = props;
    const { locale } = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement(CityLabel_1.CityLabel, { code: airport === null || airport === void 0 ? void 0 : airport.code, name: (0, MultiLanguage_1.fMultilanguage)(airport === null || airport === void 0 ? void 0 : airport.name, locale), modificators: 'bold' }));
};
exports.FlightAirportCell = FlightAirportCell;
//# sourceMappingURL=Airport.js.map